import { StyleSheet, Dimensions } from "react-native";

export const modalStyleSheet = StyleSheet.create({
  modalContainer: {
    backgroundColor: "#000000E6",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  modalBox: {
    width: Dimensions.get("window").width * 0.15,
    minHeight: 200,
    borderRadius: 20,
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: 20,
  },
  modalClose: {
    paddingVertical: 5,
    paddingHorizontal: 12,
    marginTop: 25,
    borderRadius: 20,
  },
  modalCloseText: {
    fontFamily: "Kodchasan-Bold",
  },
  modalBoxErrorBox: {
    justifyContent: "center",
    alignItems: "center",
  },
  modalBoxError: {
    fontFamily: "Roboto-Medium",
    textAlign: "center",
    paddingVertical: 3,
  },
  modalBoxWelcomeHeader: {
    fontFamily: "Roboto-Bold",
    textAlign: "center",
    fontSize: 18,
    paddingVertical: 3,
  },
  modalBoxWelcomeBody: {
    fontFamily: "Roboto-Regular",
    textAlign: "center",
    fontSize: 14,
    paddingVertical: 3,
  },
  modalBoxDelete: {
    fontFamily: "Roboto-Regular",
    textAlign: "center",
    paddingVertical: 3,
  },
  modalDelete: {
    marginTop: 25,
  },
  modalDeleteText: {
    fontSize: 12,
  },
});

export const modalInvestStyle = StyleSheet.create({
  modalContainer: {
    backgroundColor: "#000000E6",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  modalBox: {
    width: Dimensions.get("window").width * 0.15,
    borderRadius: 20,
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: 20,
  },
  modalClose: {
    borderRadius: 50,
    alignItems: "center",
    justifyContent: "space-evenly",
    flexDirection: "row",
    paddingVertical: 5,
    paddingHorizontal: 20,
  },
  modalCloseText: {
    fontFamily: "Kodchasan-Bold",
    marginLeft: 10,
  },
  moneyInputBox: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: "5%",
    flex: 1,
    width: "100%",
    marginVertical: 40,
  },
  moneyInputEuro: {
    fontFamily: "Kodchasan-Regular",
    fontSize: 44,
  },
  moneyInput: {
    textAlign: "right",
    outlineStyle: "none",
    fontFamily: "Kodchasan-Regular",
    fontSize: 34,
    minWidth: 150,
    height: "100%",
    flex: 1,
  },

  modalSaldoBox: {
    borderRadius: 10,
    borderWidth: 2,
    paddingVertical: 5,
    paddingHorizontal: 15,
  },
  modalSaldoNum: {
    textAlign: "center",
    fontFamily: "Kodchasan-Bold",
    fontSize: 18,
    lineHeight: 18,
  },
  modalSaldoText: {
    textAlign: "center",
    fontFamily: "Roboto-Medium",
    fontSize: 12,
    lineHeight: 12,
  },
});

export const snackbarStyle = StyleSheet.create({
  snackContainer: {
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
    paddingBottom: 175,
  },
  snackBox: {
    backgroundColor: "#e3eef6",
    paddingVertical: 10,
    paddingHorizontal: 20,
    maxWidth: "60%",
    borderRadius: 20,
  },
  snackText: {
    color: "#484848",
    fontFamily: "Roboto-Regular",
    textAlign: "center",
  },
});

export const helpStyle = StyleSheet.create({
  helpContainer: {
    backgroundColor: "#000000E6",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row"
  },
  helpBox: {
    width: "35%",
    height: "90%",
    borderRadius: 20,
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    overflow: "hidden",
  },
  helpScroll: {
    borderRadius: 20,
    width: "100%",
  },
  helpItem: {
    width: Dimensions.get("screen").width * 0.35,
    borderRadius: 20,
    paddingVertical: 10,
    paddingHorizontal: 20,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  helpItemHeader: {
    fontFamily: "Kodchasan-Bold",
    fontSize: 18,
    marginVertical: 20,
  },
  helpItemText: {
    fontFamily: "Roboto-Regular",
    fontSize: 14,
    textAlign: "justify",
    marginBottom: 10,
  },
  helpItemSubtitle: {
    fontFamily: "Kodchasan-Bold",
    fontSize: 14,
    textAlign: "left",
    borderBottomWidth: 1,
    marginBottom: 5,
  },
  helpImage: {
    resizeMode: "contain",
    width: "100%",
    height: 200,
    marginBottom: 10,
  },
  helpImageWide: {
    resizeMode: "contain",
    width: "100%",
    height: 100,
    marginBottom: 10,
  },
  helpImageScreen: {
    resizeMode: "contain",
    width: "100%",
    height: 400,
    marginBottom: 10,
  },

  helpDotContainer: {
    height: "1%",
    width: "100%",
    marginVertical: 10,
    flexDirection: "row",
    justifyContent: "space-evenly",
  },
  helpDotBack: {
    width: "8%",
    height: "100%",
    borderRadius: 20,
  },
  helpDotFill: {
    height: "100%",
    borderRadius: 20,
  },

  helpClose: {
    marginTop: 10,
    marginBottom: 20,
  },
  helpCloseText: {
    fontFamily: "Roboto-Regular",
  },
  helpCloseTextDisabled: {
    fontFamily: "Roboto-Regular",
  },
});